{
  "pages": [
    {
      "name": "Boiler system info",
      "elements": [
        {
          "type": "panel",
          "name": "panel1",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            }
          ],
          "title": "Boiler Information",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "Modulation_control_config",
          "elements": [
            {
              "type": "dropdown",
              "name": "ModulationSignal",
              "visibleIf": "{Modulation_control} = true",
              "title": "Communication interface for setpoint specification",
              "choices": [
                {
                  "value": "0_10-Voltage^DirectCurrent",
                  "text": "Analog voltage, 0-10V range"
                },
                {
                  "value": "4cl_20-MiliAmpere^DirectCurrent",
                  "text": "Analog current, 4-20mA range"
                }
              ],
              "isRequired": true
            },
            {
              "type": "text",
              "name": "Min_property_value",
              "visibleIf": "{ModulationSignal} = \"0_10-Voltage^DirectCurrent\"",
              "title": "Temperature at 0 V signal",
              "inputType": "number",
              "isRequired": true,
              "unit": "°C"
            },
            {
              "type": "text",
              "name": "Max_property_value",
              "visibleIf": "{ModulationSignal} = \"0_10-Voltage^DirectCurrent\"",
              "title": "Temperature at 10 V signal",
              "inputType": "number",
              "isRequired": true,
              "unit": "°C"
            },
            {
              "type": "text",
              "name": "Min_property_value",
              "visibleIf": "{ModulationSignal} = \"4cl_20-MiliAmpere^DirectCurrent\"",
              "title": "Temperature at 4 mA signal",
              "inputType": "number",
              "isRequired": true,
              "unit": "°C"
            },
            {
              "type": "text",
              "name": "Max_property_value",
              "visibleIf": "{ModulationSignal} = \"4cl_20-MiliAmpere^DirectCurrent\"",
              "title": "Temperature at 20 mA signal",
              "inputType": "number",
              "isRequired": true,
              "unit": "°C"
            }
          ],
          "title": "Modulation Control Configurations"
        },
        {
          "type": "panel",
          "name": "GB_hasOnOffInput",
          "elements": [
            {
              "type": "dropdown",
              "name": "On_at",
              "visibleIf": "{OnOff_control} = true",
              "title": "What is the heat exchanger used for?",
              "choices": [
                {
                  "value": "Closed",
                  "text": "Boiler ON with BC relay closed"
                },
                {
                  "value": "Open",
                  "text": "Boiler ON with BC relay open"
                }
              ]
            }
          ],
          "title": "OnOff Control Configuration"
        },
        {
          "type": "panel",
          "name": "Heat Meter panel",
          "elements": [
            {
              "type": "boolean",
              "name": "HM_present",
              "title": "Heat meter needed?",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            },
            {
              "type": "dropdown",
              "name": "HM_location",
              "visibleIf": "{HM_present} = true",
              "title": "Where is the heat meter placed?",
              "isRequired": true,
              "choices": [
                {
                  "value": "PrimaryForward",
                  "text": "Forward"
                },
                {
                  "value": "PrimaryReturn",
                  "text": "Return"
                }
              ]
            },
            {
              "type": "text",
              "name": "HM_address",
              "visibleIf": "{HM_present} = true",
              "isRequired": true,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Heat Meter",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "pump",
          "visible": true,
          "title": "Pump",
          "elements": [
            {
              "type": "boolean",
              "name": "P_present",
              "title": "Pump present?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "dropdown",
              "name": "Pump_Controlled",
              "visibleIf": "{P_present} = true",
              "title": "Should the pump be controlled by the BuildingConnect control box or controlled by the boiler?",
              "choices": [
                {
                  "value": "ExternControl",
                  "text": "Pump Controlled by Boiler"
                },
                {
                  "value": "BuildingConnectControl",
                  "text": "Pump Controlled by BuildingConnect"
                }
              ],
              "isRequired": true
            },
            {
              "type": "dropdown",
              "name": "P_type",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "Magna3",
                  "text": "MAGNA3"
                },
                {
                  "value": "TPE",
                  "text": "TPE"
                },
                {
                  "value": "TPE2",
                  "text": "TPE2"
                },
                {
                  "value": "TPE3",
                  "text": "TPE3"
                },
                {
                  "value": "Alpha",
                  "text": "ALPHA"
                },
                {
                  "value": "UPS",
                  "text": "UPS"
                },
                {
                  "value": "Pump",
                  "text": "Other"
                }
              ],
              "visibleIf": "{P_present} = true"
            },
            {
              "type": "dropdown",
              "name": "P_location",
              "title": "Location",
              "isRequired": true,
              "choices": [
                {
                  "value": "Forward",
                  "text": "Forward"
                },
                {
                  "value": "Return",
                  "text": "Return"
                }
              ],
              "visibleIf": "{P_present} = true"
            },
            {
              "type": "boolean",
              "name": "P_connected",
              "visibleIf": "{P_type} = \"Magna3\" or {P_type} = \"TPE\" or {P_type} = \"TPE2\" or {P_type} = \"TPE3\"",
              "title": "Enable pump connectivity?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "P_address",
              "visibleIf": "{P_connected} = true",
              "isRequired": false,
              "title": "Bus address",
              "inputType": "number"
            }
          ]
        },
        {
          "type": "panel",
          "name": "Temperature_sensors_needed",
          "elements": [
            {
              "type": "boolean",
              "name": "T_F_present",
              "title": "Forward temperature sensor",
              "visibleIf": "{P_connected} != true or {P_location} = 'Return'",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            },
            {
              "type": "boolean",
              "name": "T_R_present",
              "title": "Return temperature sensor",
              "visibleIf": "{P_connected} != true  or {P_location} = 'Forward'",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            }
          ],
          "visible": false,
          "visibleIf": "{HM_present} = false",
          "title": "Temperature sensors needed"
        },
        {
          "type": "panel",
          "name": "panel2",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_F_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visible": false,
          "visibleIf": "{T_F_present} = true",
          "title": "Forward temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel11",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_R_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visible": false,
          "visibleIf": "{T_R_present} = true",
          "title": "Return temperature sensor details"
        }
      ]
    }
  ]
}